import { Directive, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
    selector: `[requiredField]`
})
export class RequiredFieldDirective implements AfterViewInit {
    constructor(private elRef: ElementRef) {
    }
    ngAfterViewInit(): void {
        this.elRef.nativeElement.innerText = "Required Field: Please enter a valid value";
        this.elRef.nativeElement.classList.add('validate');
    }
}


// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/Directives/required-field.directive.ts